






































































import { Component, InjectReactive, Prop, PropSync, Watch } from 'vue-property-decorator';
import { ConsentCondition, ConsentConditionType, EntityStatus, Product } from '@/api';
import WaterConsentConditionModalTitle from '@/components/display/water-consents/conditions/water-consent-condition-modal-title.vue';
import WaterConsentConditionType, {
	ConditionFixedDate,
} from '@/components/display/water-consents/conditions/water-consent-condition-type';

@Component({
	components: { WaterConsentConditionModalTitle },
})
export default class WaterConsentConditionTypeFixedDate extends WaterConsentConditionType<
	ConditionFixedDate
> {
	@InjectReactive('waterProduct')
	public product!: Product;

	@Prop({ required: true })
	public consentConditionType!: ConsentConditionType;

	@PropSync('formValid')
	public _formValid!: boolean;

	@Prop()
	public consentCondition!: ConsentCondition | null;

	protected volumeValue: number = 0;
	protected volumeUnit: string | null = 'litres';

	protected startMonth: number | null = null;
	protected endMonth: number | null = null;
	protected monthOptions: { text: string; value: any; days: number; disabled?: boolean }[] = [
		{ text: 'Select month...', value: null, days: 0, disabled: true },
		{ text: 'January', value: 1, days: 31 },
		{ text: 'February', value: 2, days: 28 },
		{ text: 'March', value: 3, days: 31 },
		{ text: 'April', value: 4, days: 30 },
		{ text: 'May', value: 5, days: 31 },
		{ text: 'June', value: 6, days: 30 },
		{ text: 'July', value: 7, days: 31 },
		{ text: 'August', value: 8, days: 31 },
		{ text: 'September', value: 9, days: 30 },
		{ text: 'October', value: 10, days: 31 },
		{ text: 'November', value: 11, days: 30 },
		{ text: 'December', value: 12, days: 31 },
	];

	protected startDay: number | null = null;
	protected startDayOptions: { text: string; value: any; disabled?: boolean }[] = [
		{ text: 'Select a start month...', value: null, disabled: true },
	];

	protected endDay: number | null = null;
	protected endDayOptions: { text: string; value: any; disabled?: boolean }[] = [
		{ text: 'Select an end month...', value: null, disabled: true },
	];

	protected waterMeterIds: number[] = [];
	protected waterMeterOptions: { text: string; value: any }[] = [];

	public mounted() {
		this.watchProduct();
	}

	@Watch('product', { deep: true })
	public watchProduct() {
		this.waterMeterOptions =
			this.product?.watermeters
				?.filter(
					waterMeter =>
						![EntityStatus.Removed, EntityStatus.Cancelled].includes(
							waterMeter?.status ?? EntityStatus.Live,
						),
				)
				?.map(waterMeter => ({
					text: waterMeter.name,
					value: waterMeter.id,
				}))
				?.sort((a, b) => (a.value ?? 0) - (b.value ?? 0)) ?? [];

		this.volumeValue = (<any>this.consentCondition?.parameters)?.volumeValue ?? 0;
		this.volumeUnit = (<any>this.consentCondition?.parameters)?.volumeUnit ?? 'litres';
		this.startMonth = (<any>this.consentCondition?.parameters)?.startMonth ?? null;
		this.endMonth = (<any>this.consentCondition?.parameters)?.endMonth ?? null;
		this.startDay = (<any>this.consentCondition?.parameters)?.startDay ?? null;
		this.endDay = (<any>this.consentCondition?.parameters)?.endDay ?? null;
		this.waterMeterIds = (<any>this.consentCondition?.parameters)?.waterMeterIds ?? [];

		this.validate();
	}

	@Watch('volumeValue')
	@Watch('volumeUnit')
	@Watch('periodValue')
	@Watch('periodUnit')
	@Watch('startMonth')
	@Watch('endMonth')
	@Watch('startDay')
	@Watch('endDay')
	@Watch('waterMeterIds')
	protected validate(): void {
		this._formValid =
			this.volumeValue > 0 &&
			this.volumeValue.toString().length > 0 &&
			this.startDay != null &&
			this.waterMeterIds.length > 0;
	}

	public getParameters(): ConditionFixedDate {
		return {
			volumeValue: this.volumeValue,
			volumeUnit: this.volumeUnit ?? undefined,
			startMonth: this.startMonth ?? 0,
			startDay: this.startDay ?? 0,
			endMonth: this.endMonth ?? 0,
			endDay: this.endDay ?? 0,
			waterMeterIds: this.waterMeterIds,
		};
	}

	@Watch('startMonth')
	protected onStartMonthChanged(): void {
		const days: number | null =
			this.monthOptions.find(o => o.value === this.startMonth)?.days ?? null;
		this.startDayOptions = this.getDaysForMonth(days, false);
	}

	@Watch('endMonth')
	protected onEndMonthChanged(): void {
		const days: number | null =
			this.monthOptions.find(o => o.value === this.endMonth)?.days ?? null;
		this.endDayOptions = this.getDaysForMonth(days, true);
	}

	private getDaysForMonth(
		days: number | null,
		end: boolean = false,
	): {
		text: string;
		value: any;
		disabled?: boolean;
	}[] {
		const dayOptions: { text: string; value: any; disabled?: boolean }[] = [];
		const context: string = `a${end ? 'n' : ''} ${end ? 'end' : 'start'}`;
		if (!days) {
			dayOptions.push({ text: `Select ${context} month...`, value: null, disabled: true });
			if (end) this.endDay = null;
			else this.startDay = null;
		} else {
			if (days < (end ? this.endDay ?? 0 : this.startDay ?? 0))
				if (end) this.endDay = null;
				else this.startDay = null;
			dayOptions.push({ text: `Select ${context} day...`, value: null, disabled: true });
			for (let i = 1; i <= (days ?? 0); i++) dayOptions.push({ text: `${i}`, value: i });
		}
		return dayOptions;
	}
}
